"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

var _elementUi = require("element-ui");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _SummaryPopup = _interopRequireDefault(require("@/components/SummaryPopup"));

var _dateformart = require("@/utils/dateformart");

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "statisticalMonAgent:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default,
    SummaryPopup: _SummaryPopup.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      time: null,
      statisticalText: null,
      agentOption: [],
      timeList: [(0, _dateformart.getPreviousMonBegin)(), (0, _dateformart.getPreviousMonEnd)()],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        agentId: "",
        moneyTypeTo: "",
        statisticalStartTime: "",
        statisticalEndTime: ""
      },
      viewSummary: false,
      summaryList: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['moneyTypeFromOption'])),
  created: function created() {
    // this.setDefaultTime();
    this.getAgent();
    this.getList();
  },
  methods: {
    // setDefaultTime() {
    //   var date = new Date(),
    //     y = date.getFullYear(),
    //     m = date.getMonth();
    //   var firstDay = new Date(y, m - 1, 1);
    //   var lastDay = new Date(y, m, 0);
    //   lastDay.setHours(23, 59, 59, 0);
    //   this.listQuery.timeList = [
    //     this.dateFormat(firstDay),
    //     this.dateFormat(lastDay),
    //   ];
    // },
    getAgent: function getAgent() {
      var _this = this;

      _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
        _this.agentOption = agent.data;
      }).catch(function (err) {
        _this.$notify({
          title: _this.$t("common.error"),
          message: _this.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    handleExportReport: function handleExportReport() {
      var _this2 = this;

      // let excelName = i18n.t("message.statisticalMonOrgExcel");
      var params = this.getQueryParams();

      _httpUtils.default.post("statisticalMonAgent", "excel", null, params);

      _elementUi.MessageBox.confirm(_lang.default.t("warningMessage.pleaseWaitForExportAndNavigateMessage"), _lang.default.t("warningMessage.pleaseWaitForExportAndNavigateTitle"), {
        confirmButtonText: _lang.default.t("warningMessage.exportAndNavigateConfirmButtonText"),
        cancelButtonText: _lang.default.t("warningMessage.exportAndNavigateCancelButtonText"),
        type: 'warning'
      }).then(function () {
        // route to exported excel page
        _this2.$router.push({
          name: "exportedExcel:view"
        });
      }).catch(function () {
        return null;
      });
    },
    getQueryParams: function getQueryParams() {
      var createStartTime, createEndTime;

      if (!this.timeList) {
        createStartTime = (0, _dateformart.getPreviousMonBegin)();
        createEndTime = (0, _dateformart.getPreviousMonEnd)();
      } else {
        createStartTime = this.timeList[0];
        createEndTime = this.timeList[1];
      }

      return {
        pageNum: this.listQuery.pageNum,
        pageSize: this.listQuery.pageSize,
        agentId: this.listQuery.agentId,
        moneyTypeTo: this.listQuery.moneyTypeTo,
        statisticalStartTime: createStartTime,
        statisticalEndTime: createEndTime
      };
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined || date == '-') {
        return "-";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getList: function getList() {
      var _this3 = this;

      if (!this.hasViewPermission) {
        return;
      }

      ; // Reset Summary (including change page)

      this.viewSummary = false;
      this.summaryList = [];
      this.listLoading = true;
      var params = this.getQueryParams();

      _httpUtils.default.post("statisticalMonAgent", "list", null, params).then(function (res) {
        _this3.list = res.data.rows;
        _this3.total = res.data.total; // this.statisticalText = "";

        setTimeout(function () {
          _this3.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this3.$message({
          type: "error",
          message: err.message
        });
      }).finally(function () {
        if (_this3.summaryAppended === true) {
          _this3.list.push(_this3.summaryAppendData);
        }
      });
    },
    getStatistic: function getStatistic() {
      var _this4 = this;

      var params = this.getQueryParams();

      _httpUtils.default.post("statisticalMonAgent", "sum", null, params).then(function (res) {
        var data = res.data;
        _this4.summaryList = [[{
          label: 'SMS.totalText',
          value: data.totalCount || 0,
          unit: 'SMS.tiao'
        }], [{
          label: "SMS.orderCreateFailCount",
          value: data.orderCreateFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.orderCreateSuccessCount",
          value: data.orderCreateSuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelSubmitFailCount",
          value: data.channelSubmitFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelSubmitSuccessCount",
          value: data.channelSubmitSuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelNotifyFailCount",
          value: data.channelNotifyFailCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.channelNotifySuccessCount",
          value: data.channelNotifySuccessCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.depositedCount",
          value: data.depositedCount || 0,
          unit: 'SMS.tiao'
        }, {
          label: "SMS.refundCount",
          value: data.refundCount || 0,
          unit: 'SMS.tiao'
        }], [{
          label: "SMS.amountOfConsumption",
          value: data.processConsumeAmount,
          unit: "USD"
        }, {
          label: "SMS.channelCost",
          value: data.processChannelCostAmount,
          unit: "USD"
        }, {
          label: "SMS.agencyProfit",
          value: data.processAgentIncomeAmount,
          unit: "USD"
        }, {
          label: "SMS.platformProfit",
          value: data.processIncomeAmount,
          unit: "USD"
        }]];
      }).catch(function (err) {
        _this4.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }).finally(function () {
        _this4.viewSummary = true;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList(); // Reset Summary only when filter change
      // this.viewSummary = false;
      // this.summaryList = [];
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;